import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon, XIcon, ZoomInIcon, ZoomOutIcon } from 'lucide-react';
export function Gallery() {
  const images = [{
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4SEKCjtULCjbMcSvWumfAu/cuza_voda_poza_1.png',
    caption: 'Fațada principală - Vedere de ansamblu'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/h3v3LXhTm5wV37WYqvvQ7z/PHOTO-2025-09-30-12-14-10_%283%29.jpg',
    caption: 'Spațiu office interior - Vedere de ansamblu'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/4c3L3b4vXsAxN1MfVZiZAH/PHOTO-2025-09-30-12-14-10_%286%29.jpg',
    caption: 'Spații office - Finisaje premium'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/beHcVCfgmuXdX9xir31Y38/PHOTO-2025-09-30-12-14-11_%281%29.jpg',
    caption: 'Spațiu deschis - Potențial de amenajare'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7s3KavxNSP1FxpvqLKTn5n/PHOTO-2025-09-30-12-14-10_%285%29.jpg',
    caption: 'Hol de acces - Finisaje moderne'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/2ne5nr3mw6PJdjKuzVmrR9/IMG_4347.jpg',
    caption: 'Spațiu interior - Pardoseală din granit lustruit'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/5viR5TkPbC8U4FAPN9GEhw/IMG_4350.jpg',
    caption: 'Open space - Ferestre panoramice'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bHeuZPuySQYyyD3b714sKy/IMG_4351.jpg',
    caption: 'Terasă ultimul nivel - Potențial penthouse'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gHvUTE93P7ZG4znVs6Uhtv/IMG_4358.jpg',
    caption: 'Hol lift - Acces la ambele corpuri'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tJWdsGdvRHZjFopoqAafdc/IMG_4386.jpg',
    caption: 'Zona lift - Finisaje din piatră naturală'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/384dgxkV5dGXwqTQLnREAx/IMG_4368.jpg',
    caption: 'Birou amenajat - Mobilier inclus'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/f3mx1TEnhB9z4XVSnKXgiE/IMG_4372.jpg',
    caption: 'Spațiu de lucru - Layout flexibil'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/6DDWXawPw1hoRVKzGJRVMy/IMG_4393.jpg',
    caption: 'Sală de conferințe - Mobilier premium'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gkEpHYdC5chhmjyEh7kaoF/IMG_4408.jpg',
    caption: 'Birou individual - Spațiu generos'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jH2g4wTBRkdRVnc3XWoVLm/IMG_4444.jpg',
    caption: 'Scară interioară - Finisaje din granit'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7TQj997ZMWs3S8cvTsCdfB/IMG_4366.jpg',
    caption: 'Grup sanitar - Finisaje moderne alb-negru'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tCY8edMR8eFkx9YAaVYNkd/IMG_4393.jpg',
    caption: 'Sală întâlniri - Spațiu complet echipat'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iwo3zLWj8vYbS24ZvNsgUi/IMG_4399.jpg',
    caption: 'Open space - Lumină naturală abundentă'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/hgCguNR1hatrB5h6Sgp6ZM/IMG_4412.jpg',
    caption: 'Zonă relaxare - Amenajare premium'
  }, {
    url: 'https://uploadthingy.s3.us-west-1.amazonaws.com/mv59uQLHhjgyAtfwJsGwvS/IMG_4422.jpg',
    caption: 'Grup sanitar - Finisaje ceramice'
  }];
  const [currentIndex, setCurrentIndex] = useState(0);
  const [[page, direction], setPage] = useState([0, 0]);
  const [isFullscreen, setIsFullscreen] = useState(false);
  const [zoomLevel, setZoomLevel] = useState(1);
  const paginate = (newDirection: number) => {
    const newIndex = (currentIndex + newDirection + images.length) % images.length;
    setCurrentIndex(newIndex);
    setPage([page + newDirection, newDirection]);
  };
  const openFullscreen = () => {
    setIsFullscreen(true);
    setZoomLevel(1);
  };
  const closeFullscreen = () => {
    setIsFullscreen(false);
    setZoomLevel(1);
  };
  const handleZoomIn = () => {
    setZoomLevel(prev => Math.min(prev + 0.25, 3));
  };
  const handleZoomOut = () => {
    setZoomLevel(prev => Math.max(prev - 0.25, 0.5));
  };
  // Keyboard navigation
  useEffect(() => {
    if (!isFullscreen) return;
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        closeFullscreen();
      } else if (e.key === 'ArrowLeft') {
        paginate(-1);
      } else if (e.key === 'ArrowRight') {
        paginate(1);
      } else if (e.key === '+' || e.key === '=') {
        handleZoomIn();
      } else if (e.key === '-') {
        handleZoomOut();
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isFullscreen, currentIndex, page]);
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 1000 : -1000,
      opacity: 0
    }),
    center: {
      zIndex: 1,
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      zIndex: 0,
      x: direction < 0 ? 1000 : -1000,
      opacity: 0
    })
  };
  return <section className="py-12 md:py-20 px-4 md:px-6 lg:px-16 bg-gray-50" data-id="element-115">
      <div className="max-w-7xl mx-auto" data-id="element-116">
        <motion.h2 className="text-2xl md:text-3xl lg:text-5xl font-bold text-[#132c53] text-center mb-8 md:mb-16 px-4" initial={{
        y: -50,
        opacity: 0
      }} whileInView={{
        y: 0,
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} data-id="element-117">
          Galerie <span className="text-[#357beb]" data-id="element-118">Foto</span>
        </motion.h2>
        <div className="relative" data-id="element-119">
          {/* Main Image */}
          <div className="relative aspect-[4/3] md:aspect-[16/9] rounded-xl md:rounded-2xl overflow-hidden shadow-xl cursor-pointer group" data-id="element-120">
            <AnimatePresence initial={false} custom={direction} data-id="element-121">
              <motion.div key={page} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                type: 'spring',
                stiffness: 300,
                damping: 30
              },
              opacity: {
                duration: 0.2
              }
            }} className="absolute inset-0" onClick={openFullscreen} data-id="element-122">
                <img src={images[currentIndex].url} alt={images[currentIndex].caption} className="w-full h-full object-cover" data-id="element-123" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#132c53]/80 via-transparent to-transparent" data-id="element-124" />
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center" data-id="element-125">
                  <ZoomInIcon className="w-16 h-16 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-126" />
                </div>
              </motion.div>
            </AnimatePresence>
            {/* Navigation Buttons */}
            <button onClick={e => {
            e.stopPropagation();
            paginate(-1);
          }} className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 p-2 md:p-3 bg-white hover:bg-gray-100 rounded-full transition-all duration-300 z-10 hover:scale-110 shadow-lg touch-manipulation" aria-label="Previous image" data-id="element-127">
              <ChevronLeftIcon className="w-5 h-5 md:w-6 md:h-6 text-[#132c53]" data-id="element-128" />
            </button>
            <button onClick={e => {
            e.stopPropagation();
            paginate(1);
          }} className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 p-2 md:p-3 bg-white hover:bg-gray-100 rounded-full transition-all duration-300 z-10 hover:scale-110 shadow-lg touch-manipulation" aria-label="Next image" data-id="element-129">
              <ChevronRightIcon className="w-5 h-5 md:w-6 md:h-6 text-[#132c53]" data-id="element-130" />
            </button>
          </div>
          {/* Thumbnails */}
          <div className="mt-4 md:mt-6 grid grid-cols-5 gap-2 md:gap-4" data-id="element-131">
            {images.map((image, index) => <motion.button key={index} onClick={() => {
            setCurrentIndex(index);
            setPage([index, index > currentIndex ? 1 : -1]);
          }} className={`aspect-video rounded-md md:rounded-lg overflow-hidden transition-all touch-manipulation ${index === currentIndex ? 'ring-2 md:ring-4 ring-[#357beb] scale-105' : 'opacity-60 hover:opacity-100'}`} whileHover={{
            scale: 1.05
          }} whileTap={{
            scale: 0.95
          }} data-id="element-132">
                <img src={image.url} alt={`Thumbnail ${index + 1}`} className="w-full h-full object-cover" data-id="element-133" />
              </motion.button>)}
          </div>
        </div>
      </div>
      {/* Fullscreen Modal */}
      <AnimatePresence data-id="element-134">
        {isFullscreen && <motion.div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-135">
            {/* Close Button */}
            <motion.button onClick={closeFullscreen} className="absolute top-4 right-4 p-3 bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 z-20 group" initial={{
          scale: 0,
          rotate: -180
        }} animate={{
          scale: 1,
          rotate: 0
        }} exit={{
          scale: 0,
          rotate: 180
        }} transition={{
          duration: 0.3
        }} aria-label="Close fullscreen" data-id="element-136">
              <XIcon className="w-6 h-6 text-white group-hover:rotate-90 transition-transform duration-300" data-id="element-137" />
            </motion.button>
            {/* Zoom Controls */}
            <motion.div className="absolute top-4 right-20 flex gap-2 z-20" initial={{
          scale: 0,
          y: -20
        }} animate={{
          scale: 1,
          y: 0
        }} exit={{
          scale: 0,
          y: -20
        }} transition={{
          duration: 0.3,
          delay: 0.1
        }} data-id="element-138">
              <button onClick={handleZoomOut} className="p-3 bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed" disabled={zoomLevel <= 0.5} aria-label="Zoom out" data-id="element-139">
                <ZoomOutIcon className="w-6 h-6 text-white" data-id="element-140" />
              </button>
              <button onClick={handleZoomIn} className="p-3 bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed" disabled={zoomLevel >= 3} aria-label="Zoom in" data-id="element-141">
                <ZoomInIcon className="w-6 h-6 text-white" data-id="element-142" />
              </button>
            </motion.div>
            {/* Image Container */}
            <div className="relative w-full h-full flex items-center justify-center p-4 overflow-hidden" data-id="element-143">
              <AnimatePresence mode="wait" custom={direction} data-id="element-144">
                <motion.div key={page} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
              x: {
                type: 'spring',
                stiffness: 300,
                damping: 30
              },
              opacity: {
                duration: 0.2
              }
            }} className="absolute inset-0 flex items-center justify-center" data-id="element-145">
                  <motion.img src={images[currentIndex].url} alt={images[currentIndex].caption} className="max-w-full max-h-full object-contain" animate={{
                scale: zoomLevel
              }} transition={{
                duration: 0.3
              }} data-id="element-146" />
                </motion.div>
              </AnimatePresence>
            </div>
            {/* Navigation Arrows */}
            <motion.button onClick={() => paginate(-1)} className="absolute left-4 top-1/2 -translate-y-1/2 p-4 bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 z-20 hover:scale-110" initial={{
          x: -50,
          opacity: 0
        }} animate={{
          x: 0,
          opacity: 1
        }} exit={{
          x: -50,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} aria-label="Previous image" data-id="element-147">
              <ChevronLeftIcon className="w-8 h-8 text-white" data-id="element-148" />
            </motion.button>
            <motion.button onClick={() => paginate(1)} className="absolute right-4 top-1/2 -translate-y-1/2 p-4 bg-white/10 hover:bg-white/20 rounded-full transition-all duration-300 z-20 hover:scale-110" initial={{
          x: 50,
          opacity: 0
        }} animate={{
          x: 0,
          opacity: 1
        }} exit={{
          x: 50,
          opacity: 0
        }} transition={{
          duration: 0.3
        }} aria-label="Next image" data-id="element-149">
              <ChevronRightIcon className="w-8 h-8 text-white" data-id="element-150" />
            </motion.button>
            {/* Image Caption */}
            <motion.div className="absolute bottom-8 left-1/2 -translate-x-1/2 bg-black/50 backdrop-blur-sm px-6 py-3 rounded-full" initial={{
          y: 50,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} exit={{
          y: 50,
          opacity: 0
        }} transition={{
          duration: 0.3,
          delay: 0.2
        }} data-id="element-151">
              <p className="text-white text-sm md:text-base font-medium" data-id="element-152">
                {images[currentIndex].caption}
              </p>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}